import { useLogout } from '@common/hooks/useLogout';
import { Button } from '@radix-ui/themes';
import { Trans } from 'react-i18next';

export const LogoutButton = () => {
    const { handleLogout, isLoading } = useLogout();

    return (
        <Button
            onClick={handleLogout}
            loading={isLoading}
            color='gray'
            highContrast
        >
            <Trans i18nKey={'buttons.logout'} />
        </Button>
    );
};
